'use client';

import { c as _c } from "react/compiler-runtime";
import { lookup } from '@cruz-com/lookup';
import { useClose } from '@headlessui/react';
import { deleteCookie } from 'cookies-next/client';
import _ from 'lodash';
import Link from 'next/link';
import { redirect, usePathname } from 'next/navigation';
import { FiLogOut } from 'react-icons/fi';
import { HiPlus } from 'react-icons/hi2';
import { VscFeedback } from 'react-icons/vsc';
import slugify from 'slugify';
import { twMerge } from 'tailwind-merge';
import { CruzIcon, Logo } from '@/components';
import { currentYear, highlyRatedVehicles, infoPages, pages, popularCategories, researchPages, vehicleSitemapPages } from '@/settings';
import { useGlobalStore } from '@/store/provider';
const menuStyle = 'px-4 py-3 text-base bg-white dark:bg-zinc-950 hover:bg-zinc-100 dark:hover:bg-zinc-700 flex items-center gap-x-2 truncate font-medium dark:font-normal tracking-wide';
const categoryStyle = 'text-pretty text-xl font-bold px-4 py-2 bg-white dark:bg-transparent';
const gridStyle = 'grid grid-cols-2 gap-[1px] bg-zinc-200 dark:bg-zinc-700 border-t border-b mb-4';
type MenuProps = {
  name: string;
  menu?: string;
  icon?: React.ReactNode;
  href: string;
  count?: number;
};
export function NavMobileSide() {
  const $ = _c(104);
  const pathname = usePathname();
  const {
    user,
    setUser,
    setToast,
    setShowFeedback
  } = useGlobalStore(_temp);
  const close = useClose();
  let t0;
  if ($[0] !== close || $[1] !== pathname || $[2] !== setToast || $[3] !== setUser) {
    t0 = function signOut() {
      close();
      setUser(null, null);
      deleteCookie("access_token");
      deleteCookie("refresh_token");
      if (_.includes(pathname, "/my")) {
        redirect(pages.home.href);
      } else {
        setToast({
          type: "success",
          message: "Successfully signed out"
        });
      }
    };
    $[0] = close;
    $[1] = pathname;
    $[2] = setToast;
    $[3] = setUser;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const signOut = t0;
  let t1;
  if ($[5] !== close || $[6] !== setShowFeedback) {
    t1 = function showFeedback() {
      close();
      setShowFeedback(true);
    };
    $[5] = close;
    $[6] = setShowFeedback;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const showFeedback = t1;
  let t2;
  if ($[8] !== close) {
    t2 = t3 => {
      const {
        icon,
        name,
        menu,
        href,
        count
      } = t3;
      return <Link hrefLang="en" href={href} className={menuStyle} onClick={close}><span className="flex items-center gap-1.5">{icon}{menu || name}</span>{!_.isUndefined(count) && <span className="ml-1 rounded-full border px-1.5 py-0.5 text-xs font-normal">{count}</span>}</Link>;
    };
    $[8] = close;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const renderMenu = t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex justify-start px-4 pb-2"><Logo size="w-28" /></div>;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = twMerge(menuStyle, "text-lg font-medium");
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CruzIcon.Search className="size-6" />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== close) {
    t6 = <Link hrefLang="en" href={pages.vehicleSearch.href} className={t4} onClick={close}>{t5}Search All Vehicles</Link>;
    $[13] = close;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = twMerge(menuStyle, "text-lg font-medium");
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CruzIcon.AiLight className="size-6" />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== close) {
    t9 = <Link hrefLang="en" href={pages.vehicleAiSearch.href} className={t7} onClick={close}>{t8}{pages.vehicleAiSearch.name}</Link>;
    $[17] = close;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = user?.statistic?.saved_vehicle;
  let t11;
  if ($[19] !== renderMenu || $[20] !== t10) {
    t11 = renderMenu({
      ...pages.mySavedVehicle,
      count: t10
    });
    $[19] = renderMenu;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = user?.statistic?.saved_search;
  let t13;
  if ($[22] !== renderMenu || $[23] !== t12) {
    t13 = renderMenu({
      ...pages.mySavedSearch,
      count: t12
    });
    $[22] = renderMenu;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = _.isEmpty(user) ? pages.vehicleRecentlyViewed : pages.myRecentlyViewed;
  let t15;
  if ($[25] !== renderMenu || $[26] !== t14) {
    t15 = renderMenu({
      ...t14
    });
    $[25] = renderMenu;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t11 || $[29] !== t13 || $[30] !== t15 || $[31] !== t6 || $[32] !== t9) {
    t16 = <div className="divide-y border-t border-b">{t6}{t9}{t11}{t13}{t15}</div>;
    $[28] = t11;
    $[29] = t13;
    $[30] = t15;
    $[31] = t6;
    $[32] = t9;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className={twMerge(categoryStyle, "mt-4")}>Popular Categories</div>;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== renderMenu) {
    t18 = _.map(popularCategories, (d, idx) => <div key={`pc_${idx}`}>{renderMenu(d)}</div>);
    $[35] = renderMenu;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <li className="bg-white dark:bg-zinc-800" />;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t18) {
    t20 = <ul className={gridStyle}>{t18}{t19}</ul>;
    $[38] = t18;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className={categoryStyle}>Body Styles</div>;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== close) {
    t22 = _.map(lookup.vehicle.bodyType, (v, idx_0) => <Link hrefLang="en" key={idx_0} href={`/vehicles/body-style-s/${slugify(v.sName, {
      lower: true
    })}/${v.id}`} className={menuStyle} onClick={close}>{v.sName}</Link>);
    $[41] = close;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t22) {
    t23 = <div className={gridStyle}>{t22}</div>;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className={categoryStyle}>Highly Rated</div>;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== close) {
    t25 = _.map(highlyRatedVehicles, (d_0, idx_1) => <Link hrefLang="en" key={`highlyRated_${idx_1}`} href={d_0.href} className={menuStyle} onClick={close}>{d_0.menu}</Link>);
    $[46] = close;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t25) {
    t26 = <div className={gridStyle}>{t25}</div>;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className={categoryStyle}>Max Seatings</div>;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== close) {
    t28 = _.map(lookup.vehicle.seats, (d_1, idx_2) => <Link hrefLang="en" key={`bySeats_${idx_2}`} href={`/vehicles/seats/${d_1.name}/${d_1.id}`} className={menuStyle} onClick={close}>{d_1.name} Seats</Link>);
    $[51] = close;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className={menuStyle} />;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t28) {
    t30 = <div className={gridStyle}>{t28}{t29}</div>;
    $[54] = t28;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  let t32;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className={categoryStyle}>Browse More</div>;
    t32 = twMerge(gridStyle, "grid-cols-1");
    $[56] = t31;
    $[57] = t32;
  } else {
    t31 = $[56];
    t32 = $[57];
  }
  let t33;
  if ($[58] !== close) {
    t33 = _.map(vehicleSitemapPages, (d_2, idx_3) => <Link hrefLang="en" key={`vSitemapPage_${idx_3}`} href={d_2.href} className={menuStyle} onClick={close}>{d_2.name}</Link>);
    $[58] = close;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== t33) {
    t34 = <div className={t32}>{t33}</div>;
    $[60] = t33;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className={twMerge(categoryStyle, "mt-4")}>Research</div>;
    $[62] = t35;
  } else {
    t35 = $[62];
  }
  let t36;
  if ($[63] !== renderMenu) {
    t36 = _.map(researchPages, (d_3, idx_4) => <div key={`ips_${idx_4}`}>{renderMenu(d_3)}</div>);
    $[63] = renderMenu;
    $[64] = t36;
  } else {
    t36 = $[64];
  }
  let t37;
  if ($[65] !== t36) {
    t37 = <div className="divide-y border-t border-b">{t36}</div>;
    $[65] = t36;
    $[66] = t37;
  } else {
    t37 = $[66];
  }
  let t38;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <div className={twMerge(categoryStyle, "mt-4")}>Spotted</div>;
    $[67] = t38;
  } else {
    t38 = $[67];
  }
  let t39;
  if ($[68] !== renderMenu) {
    t39 = <div className="divide-y border-t border-b">{renderMenu(pages.spotted)}{renderMenu(pages.postSpotted)}</div>;
    $[68] = renderMenu;
    $[69] = t39;
  } else {
    t39 = $[69];
  }
  let t40;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <div className={twMerge(categoryStyle, "mt-4")}>For Dealers</div>;
    $[70] = t40;
  } else {
    t40 = $[70];
  }
  let t41;
  if ($[71] !== renderMenu) {
    t41 = <div className="divide-y border-t border-b">{renderMenu(pages.forDealers)}</div>;
    $[71] = renderMenu;
    $[72] = t41;
  } else {
    t41 = $[72];
  }
  let t42;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className={twMerge(categoryStyle, "mt-4")}>My Cruz</div>;
    $[73] = t42;
  } else {
    t42 = $[73];
  }
  let t43;
  if ($[74] !== renderMenu || $[75] !== signOut || $[76] !== user) {
    t43 = user ? <div className="divide-y border-t border-b">{renderMenu(pages.myCruz)}{renderMenu({
        ...pages.mySavedSearch,
        count: user?.statistic?.saved_search || 0
      })}{renderMenu({
        ...pages.mySavedVehicle,
        count: user?.statistic?.saved_vehicle || 0
      })}{renderMenu({
        ...pages.myAskCruzAi,
        count: user?.statistic?.ai_search_count || 0
      })}{renderMenu({
        ...pages.myRecentlyViewed,
        count: user?.statistic?.recently_viewed_count || 0
      })}{renderMenu({
        ...pages.myInquiries,
        count: user?.statistic?.inquiry_count || 0
      })}{renderMenu({
        ...pages.myVehicles,
        count: user?.statistic?.vehicle?.all || 0
      })}{renderMenu({
        ...pages.postVehicle,
        icon: <HiPlus className="w-4" />
      })}{renderMenu({
        ...pages.mySpotted,
        count: user?.statistic?.spotted_count || 0
      })}{renderMenu({
        ...pages.postSpotted,
        icon: <HiPlus className="w-4" />
      })}{renderMenu(pages.myProfile)}{renderMenu(pages.myPassword)}<button type="button" className={menuStyle} onClick={signOut}><FiLogOut className="size-4" />Sign Out</button></div> : <div className="divide-y border-t border-b">{renderMenu(pages.signIn)}{renderMenu(pages.forgotPassword)}{renderMenu(pages.joinCruz)}</div>;
    $[74] = renderMenu;
    $[75] = signOut;
    $[76] = user;
    $[77] = t43;
  } else {
    t43 = $[77];
  }
  let t44;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <div className={twMerge(categoryStyle, "mt-4")}>Information</div>;
    $[78] = t44;
  } else {
    t44 = $[78];
  }
  let t45;
  if ($[79] !== renderMenu) {
    t45 = _.map(infoPages, (d_4, idx_5) => <div key={`ips_${idx_5}`}>{renderMenu(d_4)}</div>);
    $[79] = renderMenu;
    $[80] = t45;
  } else {
    t45 = $[80];
  }
  let t46;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = twMerge(menuStyle, "w-full");
    $[81] = t46;
  } else {
    t46 = $[81];
  }
  let t47;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <VscFeedback className="mr-2 size-5" />;
    $[82] = t47;
  } else {
    t47 = $[82];
  }
  let t48;
  if ($[83] !== showFeedback) {
    t48 = <button type="button" className={t46} onClick={showFeedback}>{t47}Feedback</button>;
    $[83] = showFeedback;
    $[84] = t48;
  } else {
    t48 = $[84];
  }
  let t49;
  if ($[85] !== t45 || $[86] !== t48) {
    t49 = <div className="divide-y border-t border-b">{t45}{t48}</div>;
    $[85] = t45;
    $[86] = t48;
    $[87] = t49;
  } else {
    t49 = $[87];
  }
  let t50;
  if ($[88] !== t16 || $[89] !== t20 || $[90] !== t23 || $[91] !== t26 || $[92] !== t30 || $[93] !== t34 || $[94] !== t37 || $[95] !== t39 || $[96] !== t41 || $[97] !== t43 || $[98] !== t49) {
    t50 = <nav className="flex flex-1 flex-col">{t16}{t17}{t20}{t21}{t23}{t24}{t26}{t27}{t30}{t31}{t34}{t35}{t37}{t38}{t39}{t40}{t41}{t42}{t43}{t44}{t49}</nav>;
    $[88] = t16;
    $[89] = t20;
    $[90] = t23;
    $[91] = t26;
    $[92] = t30;
    $[93] = t34;
    $[94] = t37;
    $[95] = t39;
    $[96] = t41;
    $[97] = t43;
    $[98] = t49;
    $[99] = t50;
  } else {
    t50 = $[99];
  }
  let t51;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <div>© 2017-{currentYear}</div>;
    $[100] = t51;
  } else {
    t51 = $[100];
  }
  let t52;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <div className="flex gap-x-2 px-4 text-sm font-medium subpixel-antialiased dark:font-light">{t51}<div>Cruz<sup className="ml-0.5 text-[7px] font-medium">TM</sup></div></div>;
    $[101] = t52;
  } else {
    t52 = $[101];
  }
  let t53;
  if ($[102] !== t50) {
    t53 = <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white pt-8 pb-16 dark:bg-zinc-950">{t3}{t50}{t52}</div>;
    $[102] = t50;
    $[103] = t53;
  } else {
    t53 = $[103];
  }
  return t53;
}
function _temp(state) {
  return state;
}